export const defaults = {
  queueingEnabled: true,
  lifeTimeMs: 5000,
  showDelayMs: 100,
  backgroundColor: 'linear-gradient(to top right, #9ce29c, #c9f9b9)',
  borderColor: '#34a40e',
  textColor: 'black',
  widthMode: 'partial',
  closeButtonEnabled: true,
  useHtml: false
};
